import { CENTRA_MARKET_CODE, type CentraMarketCode } from "@/data/supported-markets"

export type MarketCodeToMarketIdMap = Map<CentraMarketCode, number>
export type MarketId =
    typeof marketCodeToMarketIdMap extends Map<any, infer V> ? V : never

const marketCodeToMarketIdMap: MarketCodeToMarketIdMap = new Map<
    CentraMarketCode,
    number
>([
    [CENTRA_MARKET_CODE.Jp, 1],
    [CENTRA_MARKET_CODE.Eu, 4],
    [CENTRA_MARKET_CODE.Na, 5],
    [CENTRA_MARKET_CODE.Apac, 6]
])

export default marketCodeToMarketIdMap
